import aemClientService from '@/services/aem/aemClientService';

let config;

const initConfig = async (market) => {
    const configData = await aemClientService.initMarketConfig(market);
    const settingsData = await aemClientService.initMarketSettings(market);
    const configDataStatic = await aemClientService.initMarketConfigStatic(market);

    config = {...configData, ...settingsData, ...configDataStatic};
};

const getConfig = () => config || {};

const getLoyaltyConfig = () => getConfig().loyalty || {};

const getPagesConfig = () => getConfig().pages || {};

const getBannersConfig = () => getConfig().banners || {};

const getMediaConfig = () => getConfig().media || {};

const getLoyaltySettings = () => getConfig().loyaltySettings || {};

export {getBannersConfig, getConfig, getLoyaltyConfig, getLoyaltySettings, getMediaConfig, getPagesConfig, initConfig};
